import { Model } from '@shared-features/models/model';
import { Expose } from 'class-transformer';

export class Humidity extends Model {
  @Expose() detectedAt: Date;
  @Expose() humidity: number;
  @Expose() isEmailSent: boolean;
}
